import { Navigate, Route, Routes } from "react-router-dom";
import LijjatScanHistoryPage from "./components/Lijjat/LocationHistory/LijjatScanHistoryPage";
import LijjatScannedProductPage from "./components/Lijjat/LocationHistory/LijjatScannedProductPage";
import LijjatProductVerificationPage from "./components/Lijjat/ProductAuthentication/LijjatProductVerificationPage";
import BhagwatiProductDetailsPage from "./components/ShreeBhagwati/ProductDetails/BhagwatiProductDetailsPage";
import RamatechScanHistoryPage from "./components/Ramatech/LocationHistory/RamatechScanHistoryPage";
import RamatechScannedProductPage from "./components/Ramatech/LocationHistory/RamatechScannedProductPage";
import RamatechProductVerificationPage from "./components/Ramatech/ProductAuthentication/RamatechProductVerificationPage";
import ShubhamScanHistoryPage from "./components/Shubham/LocationHistory/ShubhamScanHistoryPage";
import ShubhamScannedProductPage from "./components/Shubham/LocationHistory/ShubhamScannedProductPage";
import ShubhamProductVerificationPage from "./components/Shubham/ProductAuthentication/ShubhamProductVerificationPage";
import "./index.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to="/lijjat/locations" replace />} />
        <Route path="/Lijjat/:token" element={<LijjatProductVerificationPage />} />
        <Route path="/Lijjat/locations" element={<LijjatScanHistoryPage />} />
        <Route
          path="/Lijjat/scanned-products/:RSNID"
          element={<LijjatScannedProductPage />}
        />
        <Route path="/ShreeBhagwati/:sku" element={<BhagwatiProductDetailsPage />} />
        <Route path="/Shubham/:token" element={<ShubhamProductVerificationPage />} />
        <Route path="/Shubham/locations" element={<ShubhamScanHistoryPage />} />
        <Route
          path="/Shubham/scanned-products/:RSNID"
          element={<ShubhamScannedProductPage />}
        />
        <Route path="/Ramatech/:token" element={<RamatechProductVerificationPage />} />
        <Route path="/Ramatech/locations" element={<RamatechScanHistoryPage />} />
        <Route
          path="/Ramatech/scanned-products/:RSNID"
          element={<RamatechScannedProductPage />}
        />
        <Route path="*" element={<Navigate to="/lijjat/locations" replace />} />
      </Routes>
    </div>
  );
}

export default App;
